import { FunctionComponent } from 'react';
import SimpleBar from 'simplebar-react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import Stack from '@mui/material/Stack';
import { ToggleExpandButton } from '@cbridge-tools/button';
import { NavigationItemVerticalPadding } from '@cbridge-tools/navigation-item';
import { SectionLabelTypography } from '@cbridge-tools/typografy';
import { FilterBlockItems } from '../../item/FilterBlockItems/FilterBlockItems';
import { FilterBlockContext } from './FilterBlock.context';
import { IFilterBlockProps } from './FilterBlock.interface';

export const FilterBlock: FunctionComponent<IFilterBlockProps> = (props) => {
  const {
    label, items, clearFilterAction, FilterBlockItemComponent, isCollapsed, toggleCollapsed, hasSiblings,
  } = props;

  return (
    <Stack sx={{
      height: '100%',
    }}>
      <Stack
        direction={'row'}
        sx={{
          alignItems: 'center',
          paddingRight: 1.5,
          paddingY: NavigationItemVerticalPadding.sm,
        }}>
        {hasSiblings && <ToggleExpandButton
          isExpanded={!isCollapsed}
          onChange={toggleCollapsed}
          sx={{ p: 0.25 }}
        />}
        <SectionLabelTypography
          onClick={toggleCollapsed}
          sx={{ cursor: 'pointer', paddingLeft: hasSiblings ? 0 : 1.25 }}
        >
          {label}
        </SectionLabelTypography>
        {clearFilterAction}
      </Stack>
      <Box
        sx={{
          overflow: 'hidden',
          flex: 1,
        }}>
        <SimpleBar style={{
          height: '100%',
          width: '100%',
          overflow: 'auto',
        }}>
          <Collapse in={!isCollapsed} timeout={'auto'} unmountOnExit={true}>
            <FilterBlockContext value={{ FilterBlockItemComponent }}>
              <FilterBlockItems items={items} />
            </FilterBlockContext>
          </Collapse>
        </SimpleBar>
      </Box>
    </Stack>
  );
};
